import confetti from "canvas-confetti";

const PARTICLE_COLORS = [
	"#f43f5e",
	"#f59e0b",
	"#facc15",
	"#10b981",
	"#3b82f6",
	"#8b5cf6",
	"#ec4899",
];

export const celebrate = (): void => {
	const shared = {
		colors: PARTICLE_COLORS,
		disableForReducedMotion: true,
		startVelocity: 34,
		gravity: 1.1,
		scalar: 0.9,
		ticks: 160,
	};

	void confetti({ ...shared, particleCount: 60, spread: 62, origin: { x: 0.5, y: 0.62 } });
	void confetti({ ...shared, particleCount: 28, spread: 90, origin: { x: 0.2, y: 0.7 } });
	void confetti({ ...shared, particleCount: 28, spread: 90, origin: { x: 0.8, y: 0.7 } });
};
